import { render, staticRenderFns } from "./RulesPrizesModal.vue?vue&type=template&id=8a63f95e&scoped=true"
import script from "./RulesPrizesModal.vue?vue&type=script&lang=js"
export * from "./RulesPrizesModal.vue?vue&type=script&lang=js"
import style0 from "./RulesPrizesModal.vue?vue&type=style&index=0&id=8a63f95e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a63f95e",
  null
  
)

export default component.exports